import React from "react";
import { Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import CreatorDetails from "./creatorDetails";
import { withTranslation } from "react-i18next";

const Approval = ({ item, t }) => {

    return (
        <React.Fragment>
            <div className="mx-2">
                <div>
                    <strong> {ucFirst(Modules.APPROVAL)} </strong> 
                        {t('was created for')} <strong>{t('change request')} ({item?.payload?.moduleDetails?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt}/>
                </div>
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(Approval);
